import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  IconButton,
  Tooltip,
  Fade
} from '@mui/material';
import { Autorenew, Check } from '@mui/icons-material';
import API from '../services/api';

const VoucherButton = ({ 
  supplierId, 
  onCodeGenerated, 
  initialCode = '',
  disabled = false
}) => {
  const [code, setCode] = useState(initialCode);
  const [isGenerated, setIsGenerated] = useState(false);
  
  // Estilo para el código generado
  const codeStyle = {
    fontFamily: 'monospace',
    letterSpacing: '1px',
    fontWeight: 'bold',
    color: '#1976d2',
    backgroundColor: '#f0f7ff',
    padding: '8px 12px',
    borderRadius: '4px',
    border: '1px dashed #90caf9',
    minWidth: '120px',
    textAlign: 'center',
    display: 'inline-block'
  };

  // Generar el código llamando al backend
  const generateCode = async () => {
    if (!supplierId || isGenerated) return;
    
    try {
      const response = await API.get(`/invoice/generate_voucher_code/?supplier_id=${supplierId}`);
      
      if (response.data.status === 'success') {
        setCode(response.data.voucher_code);
        onCodeGenerated(response.data.voucher_code);
        setIsGenerated(true); // Marcar como generado
      }
    } catch (error) {
      console.error('Error generating voucher code:', error);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pl:1 }}>
      <Box sx={{ 
        ...codeStyle, 
        opacity: code ? 1 : 0.7,
        borderColor: isGenerated ? '#4caf50' : '#90caf9'
      }}>
        <Typography variant="body1">
          {code || (disabled ? 'Seleccione proveedor' : 'Presiona generar')}
        </Typography>
      </Box>
      
      <Tooltip title={isGenerated ? "Código generado" : !supplierId ? "Seleccione un proveedor" : "Generar código"}>
        <span>
          <IconButton
            onClick={generateCode}
            disabled={disabled || !supplierId || isGenerated}
            color={isGenerated ? "success" : "primary"}
            sx={{
              transition: 'all 0.3s',
              '&:hover': !disabled && !isGenerated ? {
                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                transform: 'rotate(90deg)'
              } : {},
              '&.Mui-disabled': {
                opacity: isGenerated ? 1 : 0.5
              }
            }}
          >
            {isGenerated ? (
              <Check color="success" />
            ) : (
              <Autorenew />
            )}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default VoucherButton;